import { render, staticRenderFns } from "./AnnounceManage.vue?vue&type=template&id=79a57d64"
import script from "./AnnounceManage.vue?vue&type=script&lang=js"
export * from "./AnnounceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports